import type { PresenceUser } from '@colplat/protocol';

const PALETTE = ['#2563eb', '#059669', '#d97706', '#dc2626', '#7c3aed', '#0891b2', '#db2777', '#65a30d'];

function colorForUuid(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length]!;
}

function initialsFor(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return `${parts[0]![0]}${parts[parts.length - 1]![0]}`.toUpperCase();
}

/** Same derivation as services/sync's presence-user.ts — a tiny, self-contained pure function, not worth sharing across a Node service and a browser bundle. */
export function presenceUserFor(id: string, name: string): PresenceUser {
  return { id, name, initials: initialsFor(name), colorHex: colorForUuid(id) };
}
